import React from "react";
import Form from 'react-bootstrap/Form'

function Effort(props) {

	var handleEffortChange = function (range) {
		let effortValue = getEffortStringValue(range.target.value)
		props.onEffortChange(effortValue);
	}
	var getEffortStringValue = function (effortIntVal) {
		if (effortIntVal === "3") return "HIGH";
		else if (effortIntVal === "2") return "MEDIUM";
		else if (effortIntVal === "1") return "LOW";
		else return "MEDIUM";
	}
	var getEffortIntValue = function () {
		if (props.effort === 'HIGH') return 3;
		else if (props.effort === 'MEDIUM') return 2;
		else if (props.effort === 'LOW') return 1;
		else return 2;
	}

	const color = props.effort === 'HIGH' ? '#dc3545' : props.effort === 'LOW' ? '#198754' : '#ffc107';

	return (
		<div>
			<Form.Label><i className="bi bi-lightning-fill me-1"></i>Effort: <span style={{ color }}>{props.effort}</span></Form.Label>
			<div style={{ height: '90px', display: 'flex', alignItems: 'center', paddingLeft: '8px' }}>
				<input
					type="range"
					min="1" max="3"
					value={getEffortIntValue()}
					onChange={handleEffortChange}
					style={{
						transform: 'rotate(270deg)',
						width: '80px',
						accentColor: color,
						cursor: 'pointer',
					}}
				/>
				<div className="d-flex flex-column justify-content-between ms-3" style={{ height: '80px', fontSize: '0.75rem', color: '#888' }}>
					<span>HIGH</span>
					<span>MED</span>
					<span>LOW</span>
				</div>
			</div>
		</div>
	);
}

export default Effort;
